// The name is going to be displayed in one or two lines, for each line the maximum characters is MAX_CHARS_TO_DISPLAY.
// In this function we split the name at spaces, then build up the name, checking the length at each word added.
export function abbreviateName(name: string, MAX_CHARS_TO_DISPLAY = 14): string | null {
  if (name) {
    if (name.length < MAX_CHARS_TO_DISPLAY) {
      return name
    }
    if (!name.includes(' ')) {
      return displayMaxChars(name)
    }
    // Split name into individual words
    const nameSplit = name.split(' ')
    // If first word is longer than MAX_CHARS_TO_DISPLAY, return that shortened
    if (nameSplit[0].length > MAX_CHARS_TO_DISPLAY) {
      return displayMaxChars(nameSplit[0])
    }
    let newNameFirstLine = nameSplit[0]
    let i = 1
    // Add words to the first line, stopping before the first line would be longer than MAX_CHARS_TO_DISPLAY
    while (
      (newNameFirstLine + ' ' + nameSplit[i]).length < MAX_CHARS_TO_DISPLAY &&
      i < nameSplit.length
    ) {
      newNameFirstLine = newNameFirstLine + ' ' + nameSplit[i]
      i++
    }
    let newNameSecondLine = nameSplit[i]
    i++
    // Add words to the second line, stopping after the second line is longer than MAX_CHARS_TO_DISPLAY
    while (newNameSecondLine.length < MAX_CHARS_TO_DISPLAY && i < nameSplit.length) {
      newNameSecondLine = newNameSecondLine + ' ' + nameSplit[i]
      i++
    }
    // If second line is longer than MAX_CHARS_TO_DISPLAY, shorten it
    if (newNameSecondLine.length > MAX_CHARS_TO_DISPLAY) {
      newNameSecondLine = displayMaxChars(newNameSecondLine)
    }
    return `${newNameFirstLine} ${newNameSecondLine}`
  }
  return null
}

function displayMaxChars(chars: string): string {
  const MAX_CHARS_TO_DISPLAY = 14
  if (chars.length > MAX_CHARS_TO_DISPLAY) {
    return `${chars.substring(0, MAX_CHARS_TO_DISPLAY - 2)}..`
  }
  return chars
}
